import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import {
  faCommentDots,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  putAPI_Update_Response,
  postAPI_Create_A_Message,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

function Dialog({ setIsAddMsgToFalse, dialogNew }) {
  const [dialog, setDialog] = useState({
    name: '',
    displayName: '',
  });

  const handleTextChange = (e) => {
    setDialog({
      ...dialog,
      [e.target.name]: e.target.value,
      messages: [],
      tag: [],
      triggers: {},
    });
  };

  const handleSave = async () => {
    console.log('data', dialog);
    dialogNew(dialog);
    if (setIsAddMsgToFalse) {
      setIsAddMsgToFalse();
    }
  };

  const handleCancel = () => {
    if (setIsAddMsgToFalse) {
      setIsAddMsgToFalse();
    }
  };

  const Editing = () => {
    return (
      <Fragment>
        <CardTitle>
          <Row style={{ textAlign: 'left' }}>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
              </div>
            </Colxx>
            <Colxx xxs="6">
              <div className="float-right">
                <Button
                  color="primary"
                  className="add-button"
                  size="xs"
                  onClick={handleSave}
                >
                  Save
                </Button>
                <b> </b>
                <Button
                  color="light"
                  className="add-button"
                  size="xs"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row className="mb-2">
          <Colxx xxs="2">
            <Label>Name</Label>
          </Colxx>
          <Colxx xxs="3">
            <Input
              type="text"
              name="name"
              value={dialog.name}
              onChange={handleTextChange}
            ></Input>
          </Colxx>
        </Row>
        <Row className="mb-2">
          <Colxx xxs="2">
            <Label>Display Name</Label>
          </Colxx>
          <Colxx xxs="3">
            <Input
              type="text"
              name="displayName"
              value={dialog.displayName}
              onChange={handleTextChange}
            ></Input>
          </Colxx>
        </Row>
      </Fragment>
    );
  };

  return (
    <Card>
      <CardBody>{Editing()}</CardBody>
    </Card>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps)(Dialog));
